import { withI18n } from '@lingui/react'
import { bool, node } from 'prop-types'

import Modal from 'views/components/molecules/Modal'
import { i18nType } from 'views/utils/propTypes'

import './SellerModal.scss'
import { SELLER_MODAL_CONTAINER_ID, SELLER_MODAL_ID } from './names'

const SellerModal = ({ i18n, children, open }) => (
  <Modal
    {...{
      id: SELLER_MODAL_ID,
      title: i18n._('seller.modal.title'),
      open,
      size: 'medium',
    }}
  >
    <div id={SELLER_MODAL_CONTAINER_ID} />
    {children}
  </Modal>
)

SellerModal.propTypes = {
  i18n: i18nType.isRequired,
  open: bool,
  children: node,
}
SellerModal.defaultProps = {
  open: false,
  children: <div />,
}

export default withI18n()(SellerModal)
